import { HomeView } from './Home.view'

export const Home = () => {
  return <HomeView />
}
